import window from '@qutejs/window';
import { ERR, closestComp, kebabToCamel } from '@qutejs/commons';

var UpdateQueue = {
	maxNestedLoops: 50,
	queue: [],
	after: null, // routines to run after the queue is processed
	push: function(op) {
		if (!this.queue.length) { // schedule
			var self = this;
			window.setTimeout(function() {
				self.run();
			}, 0);
		}
		this.queue.push(op);
	},
	// Add a callback to be invoked after the current queue run. If the queue is empty then the callback is immediately run
	// As queue tasks may push tasks into the queue, pushing a regular task in the queue after an update does not guarantee
	// the task will be run at the end.
	// This is usefull to test (to make assertion after all the uopdates where done)
	// Usually this method is called after an update
	runAfter: function(runAfterCb) {
		if (!this.queue.length) {
			runAfterCb();
		} else {
			if (!this.after) { this.after = [runAfterCb]; }
			else { this.after.push(runAfterCb); }
		}
	},
	run: function() {
		var queue = this.queue;
		var cnt = queue.length;
		var max = cnt+this.maxNestedLoops; // allowed iteration to avoid infintite loops
		while (queue.length > 0) {
			queue[0]();
			// remove from queue after execution
			queue.shift();
			if (++cnt > max) { ERR("Possible infinite loop detected"); }
		}

		// run the 'after' routines if any
		if (this.after) {
			var after = this.after;
			for (var i=0,l=after.length; i<l; i++) {
				after[i]();
			}
			this.after = null; // clear the after array
		}
	}

};

function stopEvent(e) {
	e.preventDefault();
	e.stopPropagation();
}

// filter is a an array whoes first item is true or false. See compiler q:attrs encoding
function filterKeys(obj, filter) {
	var keys = Object.keys(obj);
	if (filter) {
		var incl = filter[0]; // true: include, false: exclude
		return keys.filter(function(key) {
			return (filter.indexOf(key, 1) > -1) === incl;
		});
	} else {
		return keys;
	}
}

function chainFnAfter(fn, prevFn) {
	return prevFn ? function(arg) {
		prevFn(arg);
		return fn(arg);
	} : fn;
}

function bindStyle(elt, value) {
	if (!value) { return; }
	var style = elt.style;
	if (Array.isArray(value)) {
		for (var i=0,l=value.length; i<l; i++) {
			Object.assign(style, value[i]);
		}
	} else { // an object
		Object.assign(style, value);
	}

}

// the listeners injected from a vm to a nested template view
// must run in parent vm, context not in template view context!
// This is why we need to use the vm from the closure scope when the listener was created
function createListener(vm, fn) {
	return function(e) {
		if (fn.call(vm, e) === false) {
			stopEvent(e);
		}
	};
}

function applyListeners(el, vm, listeners) {
	for (var key in listeners) {
		var fn = listeners[key];
		el.addEventListener(key, createListener(vm, fn));
	}
}


function SetText(el, model, expr) {
	return function() {
		var val = expr(model);
		if (val !== el.nodeValue) {
			el.nodeValue = val;
		}
	}
}

function SetAttr(el, model, key, valFn) {
	return function(changedKey) {
		//if (!changedKey || changedKey === key) {
			var val = valFn(model);
			if (el.getAttribute(key) !== val) {
				if (val == null) {
					el.removeAttribute(key);
				} else {
					el.setAttribute(key, val);
				}
			}
		//}
	}
}

/*
export function SetBindings(el, model, bindFn) {
	return function(changedKey) {
		var bindings = bindFn(model);
		for (var key in bindings) {
			var val = bindings[key];
			if (el.getAttribute(key) !== val) {
				el.setAttribute(key, val);
			}
		}
	}
}
*/
function SetInnerHTML(el, model, valFn) {
	return function() {
		var val = valFn(model);
		if (val === false) { return; } // false can be used to avoid updating
		// the check is not optimal ... and the returned el innertHTML may be different even if not changed
		if (el.innerHTML !== val) {
			el.innerHTML = val || '';
		}
	}
}

// update an user generated element through q:dom. Only used to update not to initialize
function UpdateUserDom(valueFn, model, start, end) {
	return function() {
		var val = valueFn(model);
		if (val === false) { return; } // false can be used to avoid updating

		// remove existing content
		var parent = end.parentNode;
		// remove existing content
		while (start.nextSibling && start.nextSibling !== end) {
			parent.removeChild(start.nextSibling);
		}
		val && parent.insertBefore(val, end);
	}
}

function SetDisplay(el, model, valFn) {
	return function() {
		var val = valFn(model);
		var display = el.style.display;
		// backup the current diaply when toggliong OFF to be able to restore if needed
		if (val) {
			if (display === 'none') {
				el.style.display = el.__qute_display || ''; // remove 'none'
			}
		} else if (display !== 'none') {
			if (el.__qute_display == null) { el.__qute_display = display; }
			el.style.display = 'none';
		}
	}
}


function SetToggle(el, model, valFn) {
	// valFn returns a map of attr keys to values
	return function() {
		var attrs = valFn(model);
		var keys = Object.keys(attrs);
		for (var i=0,l=keys.length;i<l;i++) {
			var key = keys[i];
			if (attrs[key]) {
				el.setAttribute(key, key);
			} else {
				el.removeAttribute(key);
			}
		}
	}
}

function SetStyle(el, model, valFn) {
	return function() {
		//TODO only if modified
		bindStyle(el, valFn(model));
	}
}

function SetProp(vm, model, key, valFn) {
	return function(changedKey) {
		//if (!changedKey || changedKey === key) {
			vm.$set(key, valFn(model));
		//}
	}
}


/*
flags is a bitset:
- bit 0 is storing the isAsync attribute: if 1 isAsync is true, otherwise if 0 isAsync is false
- bit 1 is storing the detailFactory attribute: if 1 the detail is a function which takes the original event as argument and return the detail, otherwise if 0 the detail is a regular model value function
if (flags & 1) =>  is async
if (flags & 2)
*/
function retargetEvent(el, model, srcEvent, toEvent, detailFn, flags) {
    var isAsync = flags & 1;
    var isDetailFactory = flags & 2;
	el.addEventListener(srcEvent, function(e) {
		// avoid infinite loop when emiting from a component root element a
		// custom event with the same name of the original event
		if (e.$originalEvent && e.$originalTarget === el) {
			if (e.$originalEvent.type === srcEvent) { return; }
		}

		var comp = closestComp(el);
		if (comp) {
            var targetEl = comp.$el;
			var newEvent = new window.CustomEvent(toEvent, {
				bubbles: e.bubbles,
				detail: detailFn ? (isDetailFactory ? detailFn.call(model, e) : detailFn(model)) : model
			});
			newEvent.$originalEvent = e;
			newEvent.$originalTarget = el;
			e.stopImmediatePropagation();
			e.preventDefault();
			if (isAsync) {
				window.setTimeout(function() {
					targetEl.dispatchEvent(newEvent);
				}, 0);
			} else {
				targetEl.dispatchEvent(newEvent);
			}
		}
	});
}

function applyEmitters(el, model, ar) {
	for (var i=0,l=ar.length; i<l; i+=4) {
		retargetEvent(el, model, ar[i+1], ar[i], ar[i+2], ar[i+3]);
	}
}

// ------- Element class handling -------

function _addClassesFromObject(classes, value) {
	var keys = Object.keys(value);
	for (var i=0,l=keys.length; i<l; i++) {
		var key = keys[i];
		if (value[key]) { classes.push(key); }
	}
}
function _stringifyClasses(out, value) {
	if (Array.isArray(value)) {
		for (var i=0,l=value.length; i<l; i++) {
			var val = value[i];
			if (val) {
				if (typeof val === 'string') {
                    out.push(val);
                } else { // an object?
					_addClassesFromObject(out, val);
				}
			}
		}
	} else { // an object
		_addClassesFromObject(out, value);
    }
    return out.join(' ');
}

function ClassHandler(fixedClassName) {
    // 0 - fixed or computed part set through class attribute,
    // 1 - dynamic part set through q:class
    // 2 - fixed or computed part inherited from parent component element through q:attrs
    // 3 - dyanmic part inhertied from parent component element through q:class if any
    this.parts = [fixedClassName || '','','',''];
    this.dirty = false;
}
ClassHandler.prototype = {
	// append class names to the fixed part
	add: function add(className) {
		var fixedPart = this.parts[0];
		if (fixedPart) {
			fixedPart += ' '+className;
		} else {
			fixedPart = className;
		}
		this.parts[0] = fixedPart;
        this.dirty = true;
        return this;
	},
    attr: function attr(className) {
        if (this.parts[0] !== className) {
            this.parts[0] = className;
            this.dirty = true;
        }
        return this;
    },
    qclass: function qclass(expr) {
        var className = _stringifyClasses([], expr);
        if (this.parts[1] !== className) {
            this.parts[1] = className;
            this.dirty = true;
        }
        return this;
    },
    iattr: function iattr(className) { // inject class literal from q:attrs (inherited class attribute)
        if (this.parts[2] !== className) {
            this.parts[2] = className;
            this.dirty = true;
        }
        return this;
    },
    iqclass: function iqclass(expr) {
        var className = _stringifyClasses([], expr);
        if (this.parts[3] !== className) {
            this.parts[3] = className;
            this.dirty = true;
        }
        return this;
    },
    apply: function apply(el) {
        if (this.dirty) {
            el.className = this.parts.join(' ').trim();
            this.dirty = false;
        }
    }
};

// to be used by user directives to append fixed class on an element
function AddClass(elt, value) {
    if (elt.__qute_clh__) {
        elt.__qute_clh__.add(value).apply(elt);
    } else {
        elt.className = value;
    }
}

function SetFixedClass(elt, value) {
    if (elt.__qute_clh__) {
        elt.__qute_clh__.attr(value).apply(elt);
    } else {
        elt.className = value;
    }
}

function SetComputedClass(elt, model, valFn) {
    if (!elt.__qute_clh__) {
        elt.__qute_clh__ = new ClassHandler(elt.className);
    }
	return function() {
        var value = valFn(model);
        elt.__qute_clh__.attr(value || '').apply(elt);
	}
}

function InheritClass(elt, className) {
    if (!elt.__qute_clh__) {
        elt.__qute_clh__ = new ClassHandler(elt.className);
    }
    elt.__qute_clh__.iattr(className).apply(elt);
}

function SetQClass(elt, model, valFn) {
    if (!elt.__qute_clh__) {
        elt.__qute_clh__ = new ClassHandler(elt.className);
    }
	return function() {
        var value = valFn(model);
        elt.__qute_clh__.qclass(value || '').apply(elt);
	}
}

function InheritQClass(elt, model, valFn) {
    if (!elt.__qute_clh__) {
        elt.__qute_clh__ = new ClassHandler(elt.className);
    }
	return function() {
        var value = valFn(model);
        elt.__qute_clh__.iqclass(value || '').apply(elt);
	}
}

// el is defined only when called on a DOM element
function applyUserDirectives(rendering, xattrs, el, comp) {
    var xcall, fns = [], directives = xattrs.$use;
    for (var i=0,l=directives.length; i<l; i+=2) {
        var userDir = directives[i];
        var val = directives[i+1];
        if (!userDir) { // a q:call
            xcall = val;
        } else if (userDir === 'id') { // a q:id
            rendering.app.publish(val, comp || el);
            return null;
        } else {
            var fn = userDir.call(rendering, xattrs, val, el, comp);
			if (fn) { fns.push(fn); }
        }
    }
	return (xcall || fns.length) && function(rendering, el) {
		if (xcall) { xcall.call(rendering.model, el); }
		for (var i=0,l=fns.length; i<l; i++) {
			fns[i].call(rendering, el);
		}
	}
}

/*
Detecting item updates
-----------------------

A solution to detect item updates is to clone the item so that we can check if the item instance
changed and doing the update.
The pb is that bindings are using the initial instance so we need to completely re-render the item
Another solution is to copy the modified clone over the initial instance to apply changes.
We must take care to update back the 'from' array to use the same initial instance of the changed item.
This is beacause changing the instance of the item is the signal to trigger the update.

We can also use another approach to use __dirty__ field on the array to indicate if an item changed:
__dirty__: ['key1', 'key2']

We implement both approaches

*/

var CLEAR = 0;
var SET = 1;
var REMOVE = 2;
var INSERT = 3;
var APPEND = 4;
var MOVE = 5;
// individual item updates
var UPDATE = 6;

function valueAsKey(item) {
	return String(item);
}
// supports a modification coiunt field to force updates
function ArrayDiff(key) {
	this.ar = null;
	this.map = null;
	if (key === '.') {
		this.keyOf = valueAsKey;
	} else if (typeof key === 'string') {
		this.keyOf = function(item) { return item[key] };
	} else if (key) { // expect a fn
		this.keyOf = key;
	} else {
		this.keyOf = null;
	}
}
ArrayDiff.prototype = {
	clear: function clear() {
		var wasSet = !!(this.ar && this.ar.length > 0);
		this.ar = null;
		this.map = {};
		return wasSet ? [ CLEAR ] : null;
	},
	set: function set(from) {
		if (!from || !from.length) {
			return this.clear();
		}
		var keyOf = this.keyOf;
		if (keyOf) {
			var map = {};
			for (var i=0,l=from.length; i<l; i++) {
				map[keyOf(from[i])] = true;
			}
			this.map = map;
			this.keyOf = keyOf;
		} else {
			this.map = {};
		}
		this.ar = from.slice(); // store a copy
		return [ SET, this.ar, keyOf ];
	},
	update: function update(from) {
		if (this.ar === from) {
			return null;
		}
		if (from == null || !from.length) {
			return this.clear();
		}
		if (!this.ar || !this.ar.length) {
			return this.set(from);
		}
		var keyOf = this.keyOf;
		if (!keyOf) { // reset
			return this.set(from);
		}
		var ar = this.ar;
		var map = this.map;
		var fromMap = {};
		var l1 = ar.length;
		var l2 = from.length;
		var moved = {};
		var diff = [];

		// build an index for the from array
		for (var i=0; i<l2; i++) {
			fromMap[keyOf(from[i])] = true;
		}

		var i = 0, j = 0;
		for (; j<l1 && i<l2; i++) {
            var it1 = ar[j];
			var it2 = from[i];
			var key2 = keyOf(it2);
			var key1 = keyOf(it1);

			if (moved[key1]) {
				j++; // skip moved items from dst array
				i--; // repeat current item
				continue;
			}

			if (moved[key2]) {
				// it2 already processed (moved) - skip and continue
				continue;
			}

			if (!map[key2]) {
				// a new item - insert
				if (j < l1) {
					diff.push(INSERT, it2, key2, key1);
				}
			} else {
				// item already exists
				if (key1 === key2) {
                    // detect individual item updates
                    if (it1 !== it2) {
                        // the item instance changed - we copy the changes back to the original instance
                        // and then restore the original instance on the from array otherwise we will broke the link
                        // between the item bound in the DOM change listeners and the one in the from list.
                        Object.assign(it1, it2);
                        from[i] = it1; // revert back to the original instance
                        // and we trigger an update
                        diff.push(UPDATE, key2);
                    }
					// else unchanged - continue
					j++;
				} else if (fromMap[key1]) {
					// items differs - moved
					moved[key2] = true;
					diff.push(MOVE, key2, key1);
				} else {
					// item removed
					diff.push(REMOVE, key1);
					i--; // repeat the item
					j++;
				}
			}
		}

		if (i < l2) {
			// 'ar' consumed but 'from' not consumed
			// all the remaining 'from' items must be appended if not already moved
			for (;i<l2;i++) {
				var item = from[i];
				var key = keyOf(item);
				if (!map[key]) {
					diff.push(APPEND, item, key);
				}
			}
		} else if (j < l1) {
			// 'from' consumed but 'ar' not consumed
			// remove remaining 'ar' items if they are not in from
			for (;j<l1;j++) {
				var key = keyOf(ar[j]);
				if (!fromMap[key]) {
					// item removed
					diff.push(REMOVE, keyOf(ar[j]));
				}
			}
		}

        // detect individual item changes through the hidden __dirty__ field
        if (from.__dirty__) {
            var dirty = from.__dirty__;
            if (Array.isArray(dirty)) {
                for (var i=0,l=dirty.length; i<l; i++) {
                    diff.push(UPDATE, dirty[i]);
                }
            }
            delete from.__dirty__;
        }

		if (diff.length) {
			this.ar = from.slice(); // store a copy
			this.map = fromMap;
		} // else unchanged

		return diff;
	}
};


ArrayDiff.run = function(OPS, diff) {
	if (diff) {
		for (var i=0,l=diff.length; i<l;) {
			switch (diff[i]) {
				case APPEND: // append(item, key)
					OPS.append(diff[i+1], diff[i+2]);
					i+=3;
					break;
				case INSERT: // insert(item, key, beforeKey)
					OPS.insert(diff[i+1], diff[i+2], diff[i+3]);
					i+=4;
					break;
				case REMOVE: // remove(key)
					OPS.remove(diff[i+1]);
					i+=2;
					break;
				case MOVE: // move(key, beforeKey)
					OPS.move(diff[i+1], diff[i+2]);
					i+=3;
					break;
				case SET: // set(array, keyOf)
					OPS.set(diff[i+1], diff[i+2]);
					i+=3;
					break;
				case CLEAR: // clear()
					OPS.clear();
					i++;
					break;
                case UPDATE: // individual item update: update(key)
                    OPS.updateItem(diff[i+1]);
                    i+=2;
                    break;
				default: throw new Error('Invalid diff op '+diff[i]);
			}
		}
	}
};

/*
Reqs:

1. Item need to be added/removed at runtime without causing leaks.
Each item should register its updaters to its own context so that when it is removed the
updaters are automatically removed.

Solution: use a rendering context per item. Store the context as a DOM element prop: __qute_ctx__,
so that we can easily retrieve the rendering context when removing an element.

2. Items must be notified when parent rendering connects / disconnects

Solution: the ListFragment itself implements the connect / disconnect contract of Rendering and register itself as a sub-rendering
(even if it is not a real rendering instance). It will be then called easch time the parent connect / disconnect, and will be able to connect disconnect each item rendering.
To retrieve item renderings we need to store each rendering context (from 1.) into a element property '__qute_ctx__'
this way we can connect/disconnect items by iterating over the DOM children elements.

3. Only the list expr is bound to the parent rendering model. All the other item properties will be bound to its own model (the iteration model)
The model is stored as usually in the rendering instance linked corresponding to the item (from 1.)

4. To be able to quickly update the DOM we need to store [key -> itemEElement] pairs
to quiclky retrieve an element using its key.

Solution: 1. we can keep a map or we can store the key as an element 'data-qute-key' property and use querySelector to retrieve the item.
We implement 1. for now.

5. List diff is computed only when parent context is updating and the list expression
returns a different list instance that the current rendered one.

NOTE: If you wantt to be able to update the DOM when the curren list changes (e.g. list.push(..) called)
without cloning and setting a new instance of the list then we need to impl some sort of version mechanism:
list.$version=0 which we need to increment and then manually call vm.update() to force a DOM rendering

WARN: If list is not defining an item key then updates will be costly and will render the entire list fragment. and not only the differences
(you can use '.' for primitive sets to use the value as the key)

*/

function ListFragment(rendering, listFn, itemFn, key) {
	var document = window.document;
	this.r = rendering;
	this.listFn = listFn;
	this.itemFn = itemFn;
	this.adiff = new ArrayDiff(key);
	this.items = {};
	this.start = document.createComment('[q:if]');
	this.end = document.createComment('[/q:if]');
}

ListFragment.prototype = {
	$create: function $create() {
		var frag = window.document.createDocumentFragment();
		frag.appendChild(this.start);
		frag.appendChild(this.end);
		// add the update function to the parent rendering updaters and trigger an update
		this.r.up(this.update.bind(this))();
		// register the list fragments as a sub context to be notified for connect / disconnect events.
		this.r.$push(this);
		return frag;
	},
	callItemR: function callItemR(methodName) {
		var end = this.end;
		var next = this.start.nextSibling;
		while (next && next !== end) {
			next.__qute_ctx__ && next.__qute_ctx__[methodName]();
			next = next.nextSibling;
		}
	},
	// life cycle hooks
	connect: function connect() {
		this.callItemR('connect');
	},
	disconnect: function disconnect() {
		this.callItemR('disconnect');
	},
	refresh: function refresh() {
		this.callItemR('refresh');
	},
	// TODO not uet used
	updateItems: function updateItems() {
		this.callItemR('update');
	},

	renderItem: function renderItem(r, items, key, item) {
		var itemR = r.spawn();
		var el = this.itemFn(itemR, item);
		el.__qute_ctx__ = itemR;
        el.__qute_key__ = key;
		if (key) { items[key] = el; }
		r.isc && itemR.connect();
		return el;
	},
	// update the list
	update: function update() {
        var list = this.listFn(this.r.model);
        if (list && list.__QUTE_LIST__) { // support the _List property type - see @qutejs/types
            if (!this.adiff.keyOf) {
                // use the keyOf fn declasred on the list property
                this.adiff.keyOf = list.keyOf;
            }
            // use the internal array of the list property
            list = list.ar;
        }
        if (!this.adiff.keyOf) {
            console.warn("Reactive list used without a 'q:key' attribute: Performance will suffer!");
        }
		var diff = this.adiff.update(list);
		if (diff) {
			ArrayDiff.run(this, diff);
		}
		//TODO
		//update item contexts too? or keep them isolated from parent updates?
		//this.updateItems();
	},

	// --------- ArrayDiff operations ---------
	clear: function clear() {
		//console.log('ListFragment:clear');
		this.items = null;
		var isc = this.r.isc;
		var end = this.end, start = this.start;
		var parent = end.parentNode;
		while (start.nextSibling !== end) {
			var el = start.nextSibling;
			isc && el.__qute_ctx__ && el.__qute_ctx__.disconnect();
			parent.removeChild(el);
		}
	},
	set: function set(ar, keyOf) {
		//console.log('ListFragment:set', ar, keyOf);
		this.clear();
		if (!ar || !ar.length) { return; }
		var r = this.r;
		var end = this.end;
		var parent = end.parentNode;
		if (!keyOf) {
			keyOf = function() {};
		}
		var i=0,items = {};
		for (var l=ar.length; i<l; i++) {
			var item = ar[i];
			var itemEl = this.renderItem(r, items, keyOf(item), item);
			parent.insertBefore(itemEl, end);
		}
		this.items = items;
	},
	remove: function remove(key) {
		//console.log('ListFragment:remove', key);
		var itemEl = this.items && this.items[key];
		if (itemEl) {
			itemEl.parentNode.removeChild(itemEl);
			this.r.isc && itemEl.__qute_ctx__ && itemEl.__qute_ctx__.disconnect();
			delete this.items[key];
		} else {
			console.error('cannot find cached element', key); // TODO
		}
	},
	_insert: function _insert(item, key, beforeEl) {
		var itemEl = this.renderItem(this.r, this.items, key, item, -1, false);
		beforeEl.parentNode.insertBefore(itemEl, beforeEl);
	},
	insert: function insert(item, key, beforeKey) {
		//console.log('ListFragment:insert', item, key, beforeKey);
		var beforeEl = this.items && this.items[beforeKey];
		if (beforeEl) {
			this._insert(item, key, beforeEl);
		} else {
			console.error('cannot find cached element', beforeKey); // TODO
		}
	},
	append: function append(item, key) {
		//console.log('ListFragment:append', item, key);
		this._insert(item, key, this.end);
	},
	move: function move(key, beforeKey) {
		//console.log('ListFragment:move', key, beforeKey);
		var beforeEl = this.items && this.items[beforeKey];
		var el = this.items && this.items[key];
		if (beforeEl && el) {
			beforeEl.parentNode.insertBefore(el, beforeEl);
		} else {
			console.error('cannot find cached element', key, beforeKey); // TODO
		}
	},
    // inidividual item update
    updateItem: function updateItem(key) {
        var el = this.items && this.items[key];
        if (el) {
            el.__qute_ctx__ && el.__qute_ctx__.update();
        } else {
            console.error('cannot find cached element', key); // TODO
        }
    }
};

/*
 A simple Map polyfill
 Used by the <view> directive `cache` option.
 */

function SimpleMap() {
	this.keys = [];
	this.vals = [];
}

SimpleMap.prototype = {
	set: function set(key, val) {
		var i = this.keys.indexOf(key);
		if (i < 0) {
			this.keys.push(key);
			this.vals.push(val);
		} else {
			this.keys[i] = keys;
			this.vals[i] = val;
		}
	},
	get: function get(key) {
		var i = this.keys.indexOf(key);
		return i < 0 ? void(0) : this.vals[i];
	}
};

var MapImpl = typeof Map === 'function' ? Map : SimpleMap;

/*
	- exprFn - is a model binding fn (i.e. takes a model as argument) that returns a key
	- render - is a cunftion that takes a rendering and a key as argument and return a DOM node or an array of nodes
*/
function SwitchFragment(rendering, name, exprFn, render, changeCb, nocache) {
	var document = window.document;
	this.key = null; // the active case key
	this.caseR = null;
	this.cache = nocache ? null : new MapImpl(); // key to rendering instance cache if cache is used.
	this.r = rendering;
	this.exprFn = exprFn;
	this.render = render;
	this.changeCb = changeCb;
	this.start = document.createComment('['+name+']');
	this.end = document.createComment('[/'+name+']');
}

SwitchFragment.prototype = {
	$create: function $create() {
		var frag = window.document.createDocumentFragment();
		frag.appendChild(this.start);
		frag.appendChild(this.end);
		// add the update function to the parent rendering updaters and trigger an update
		this.r.up(this.update.bind(this))(this.r.model, true);
		// register the list fragments as a sub context to be notified for connect / disconnect events.
		this.r.$push(this);
		return frag;
	},
	// ---- rendering hooks ---------
	connect: function connect() {
		this.caseR && this.caseR.connect();
	},
	disconnect: function disconnect() {
		this.caseR && this.caseR.disconnect();
	},
	refresh: function refresh() {
		this.caseR && this.caseR.refresh();
	},
	// --- end rendering hooks ------
	clear: function clear() {
		var end = this.end, start = this.start;
		var parent = end.parentNode;
		while (start.nextSibling !== end) {
			var el = start.nextSibling;
			parent.removeChild(el);
		}
		this.r.isc && this.caseR && this.caseR.disconnect();
		this.caseR = null;
	},
	update: function update(model, initialUpdate) {
		var key = this.exprFn(this.r.model);
		if (this.key !== key) { // case changed -> render case
			this.clear(); // remove existing content
			var cache = this.cache;
			var r = cache && cache.get(key);
			if (!r) {
				r = this.r.spawn();
				var nodes = this.render(r, key);
				if (nodes && !Array.isArray(nodes)) {
					nodes = [nodes];
				}
				r.$nodes = nodes;
				if (cache) { cache.set(key, r); }
			}
			// render nodes
			var nodes = r.$nodes;
			if (nodes) {
				var end = this.end;
				var parent = end.parentNode;
				for (var i=0,l=nodes.length; i<l; i++) {
					parent.insertBefore(nodes[i], end);
				}
			}
			this.caseR = r;
			this.key = key;
			this.r.isc && r.connect();
			if (!initialUpdate) {
				//TODO how we can automatically detect dirty states?
				this.caseR.update(); // force an update?
			}

			if (this.changeCb && !initialUpdate) { // avoid calling changeCb the first time the if is rendered
				this.changeCb.call(this.r.model, key);
			}
		} else if (this.caseR) {
			this.caseR.update(); // udpate
		}
	}
};

function ForFragment(rendering, listFn, iterationFn) {
	var document = window.document;
	this.r = rendering;
	this.listFn = listFn;
	this.iterationFn = iterationFn;
	this.list = null;
	this.listR = null;
	this.start = document.createComment('[for]');
	this.end = document.createComment('[/for]');
}

ForFragment.prototype = {
	$create: function $create() {
		var frag = window.document.createDocumentFragment();
		frag.appendChild(this.start);
		frag.appendChild(this.end);
		// add the update function to the parent rendering updaters and trigger an update
		this.r.up(this.update.bind(this))(this.r.model, true);
		// register the list fragments as a sub context to be notified for connect / disconnect events.
		this.r.$push(this);
		return frag;
	},
	// ---- rendering hooks ---------
	connect: function connect() {
		this.listR && this.listR.connect();
	},
	disconnect: function disconnect() {
		this.listR && this.listR.disconnect();
	},
	refresh: function refresh() {
		this.listR && this.listR.refresh();
	},
	// --- end rendering hooks ------
	clear: function clear() {
		var end = this.end, start = this.start;
		var parent = end.parentNode;
		while (start.nextSibling !== end) {
			var el = start.nextSibling;
			parent.removeChild(el);
		}
		this.r.isc && this.listR && this.listR.disconnect();
		this.listR = null;
		this.list = null;
	},
	update: function update(model, initialUpdate) {

		var list = this.listFn(this.r.model);
		if (!list) {
			this.clear();
			return;
		}
		if (list !== this.list) {
			// remove current list
			this.clear();
			this.list = list;
			if (list) {
				if (!Array.isArray(list)) {
					list = Object.keys(list);
				}
				if (list.length > 0) {
					var r = this.r.spawn();
					var iterationFn = this.iterationFn;
					var end = this.end;
					var parent = end.parentNode;
					var l = list.length-1;
					for (var i=0; i<l; i++) {
						var children = iterationFn(list[i], i, true);
						if (children) {
							for (var k=0,ll=children.length; k<ll; k++) {
								parent.insertBefore(children[k], end);
							}
						}
					}
					// append last item
					var children = iterationFn(list[l], l, false);
					if (children) {
						for (var k=0,ll=children.length; k<ll; k++) {
							parent.insertBefore(children[k], end);
						}
					}
					this.listR = r;
				}
			}
		} else if (this.listR) {
			this.listR.update();
		}
	}
};

// emitter prototype
var Emitter = {
    /**
     * Emit an event now
     * @param {string} event
     * @param {object} data
     */
	emit: function(event, data) {
		this.$el.dispatchEvent(new window.CustomEvent(event, {bubbles: true, detail: data === undefined ? this : data }));
    },
    /**
     * Emit an event after a timeout
     * @param {string} event
     * @param {object} data
     * @param {number} timeout
     */
	emitAsync: function(event, data, timeout) {
		var self = this;
		window.setTimeout(function() { self.emit(event, data); }, timeout || 0);
	}
};

/*
template components
*/

function SetFuncAttrs(func, vm, filter) { // vm is the parent vm (i.e. current model)
	return function() {
		var vmAttrs = vm.$attrs;
		if (vmAttrs) {
			var keys = filterKeys(vmAttrs, filter);
			for (var i=0,l=keys.length; i<l; i++) {
				var key = keys[i];
				func.set(key, vmAttrs[key]);
			}
		}
	}
}

function SetFuncAttr(func, vm, key, val) { // vm is the parent vm (i.e. current model)
	return function() {
		func.set(key, val(vm));
	}
}

function FunComp() {
	this.$app = null;
	this.$r = null;
	this.$el = null;
	this.$attrs = {};
	this.$slots = null;
	this.$uq = false; // updayte queued
}

FunComp.prototype = {
    __QUTE_TPL__: true,
	set: function(key, val) {
		var oldVal = this.$attrs[key];
		if (val !== oldVal) {
			this.$attrs[key] = val;
			this.update();
		}
	},
	update: function() {
		if (this.$el && !this.$uq) {
			this.$uq = true;
			var self = this;
			UpdateQueue.push(function() {
				self.$r.update();
				self.$uq = false;
			});
		}
	},
	emit: Emitter.emit,
	emitAsync: Emitter.emitAsync,
	render: function(rendering, XTag, xattrs, slots) {
		this.$r = rendering.spawn(this);
		this.$slots = slots;

		var model = rendering.model, attrs = this.$attrs, $use, $ref,
			bindings, listeners, emitters;

		if (model) {
			this.$app = model.$app;
		}

		if (xattrs) {
			$ref = xattrs.$ref;

			for (var key in xattrs) { // class, style and show, $attrs, $listeners are ignored
				var val = xattrs[key];
				if (key.charCodeAt(0) !== 36 || key === '$html') { // $ - extended attribute -> ignore all extended attrs but $html
					if (typeof val === 'function') {
						rendering.up(SetFuncAttr(this, model, key, val));
						val = val(model);
					}
					attrs[key] = val;
				} else if (key === '$attrs') {
					if (model.$attrs) {
						// inject attributes in template tags
						// we need to create an update function to reinject attrs when model changes
						// otherwise we loose the reactivity on func tags 'q:attrs' attribute
						rendering.up(SetFuncAttrs(this, model, val))();
					}
				} else if (key === '$on') {
                    listeners = val;
                } else if (key === '$emit') {
                    emitters = val;
				} else if (key === '$class') {
					if (!bindings) { bindings = []; }
					bindings.push(InheritQClass, val);
				} else if (key === '$style') {
					if (!bindings) { bindings = []; }
					bindings.push(SetStyle, val);
				} else if (key === '$show') {
					if (!bindings) { bindings = []; }
					bindings.push(SetDisplay, val);
				} else if (key === '$toggle') {
					if (!bindings) { bindings = []; }
					bindings.push(SetToggle, val);
                }
            }

            if (xattrs.$use) {
                $use = applyUserDirectives(rendering, xattrs, null, this);
            }
		}

		var el = XTag(this.$r, xattrs, slots);
		this.$el = el;
		el.__qute__ = this; // to be used by Qute.closestComp

		// apply root bindings if any (q:class, q:style or q:show)
		if (bindings) {
			for (var i=0,l=bindings.length; i<l; i+=2) {
				var up = bindings[i](el, model, bindings[i+1]);
				rendering.up(up)();
			}
        }

        if (emitters) {
            applyEmitters(el, model, emitters);
        }

		// apply listeners if any
		if (listeners) {
			applyListeners(el, model, listeners);
		}

		// call user directives if any
		if ($use) {
			$use(rendering, el);
		}
		if ($ref) { rendering.model[$ref] = this; }

		// we must push the rendering context of the fun comp
		// to propagate connect / disconnect handlers
		rendering && rendering.$push(this.$r);

		return el;
	}
};

var document = window.document;

// q:attrs values are already evaluated - so the injected values are liiterals
function SetDOMAttrs(el, model, filter) {
	return function() {
		var $attrs = model.$attrs;
		if ($attrs) {
			var keys = filterKeys($attrs, filter);
			for (var i=0,l=keys.length; i<l; i++) {
                var key = keys[i];
                if (key === 'class') {
                    // the class is handled apart to sync with q:class and other dynamkic class changes
                    InheritClass(el, $attrs[key]);
                } else {
                    el.setAttribute(key, $attrs[key]);
                }
			}
		}
	}
}

function appendChildren(parent, children) {
	for (var i=0, l=children.length; i<l; i++) { parent.appendChild(children[i]); }
}

function extractSlots(children) {
	if (children && children.length) {
		var namedSlots = {}, nestedCnt = 0, hasContent = false;
		for (var i=0,l=children.length; i<l; i++) {
			var child = children[i];
			var nodeType = child.nodeType;
			switch (nodeType) {
				case 1:
					if (child.__qute_slot__) {
						var slotChildren = [];
						var slot = child.__qute_slot__;
						if (slot.startsWith('nested:')) {
							// a fragment
							slot = slot.substring(7);
							var node = child.firstChild;
							while (node) {
								slotChildren.push(node);
								node = node.nextSibling;
							}
						} else { // use the element itself to inject in the target slot
							slotChildren.push(child);
						}
						namedSlots[slot] = slotChildren;
						nestedCnt++;
					} else {
						hasContent = true;
					}
					break;
				case 3:
					if (child.nodeValue.trim()) { hasContent = true; }
					break;
			}
		}
		if (nestedCnt) {
			return namedSlots;
		} else if (hasContent) { // default slot
			namedSlots.default = children;
			return namedSlots;
		}
	}
	return null;
}



var RenderingProto = {
    md: function(content) { // used by $html to convert markdown to html
        if (!Rendering.markdown) {
            ERR("No markdown converter defined. You need to define a Qute.Rendering.markdown(content) method");
        }
        return Rendering.markdown(content, this);
    },
	x: function(expr) { // expression {{ ... }}
		var text = expr(this.model);
		var el = document.createTextNode(text);
		this.up(SetText(el, this.model, expr));
		return el;
    },
    // check for udefied ad ull values ad out put ''
    u: function(value) {
        return value == null ? '' : value;
    },
	t: function(value) { // text
		return document.createTextNode(value);
	},
	g: function(isFn, xattrs, children) { // dynamic tag using 'is'
        var tagOrFn = isFn(this.model);
        if (!tagOrFn) {
            ERR('<q:tag> directive failed: "is" attribute resolve to a falsy value');
        }
        return typeof tagOrFn === 'string' ? this.h(tagOrFn, xattrs, children) : this.c(tagOrFn, xattrs, children);
	},
    h: function(tag, xattrs, children, svg) { // dom node
		var el = svg ? document.createElementNS('http://www.w3.org/2000/svg', tag)
            : document.createElement(tag), $use = null;
		if (xattrs) {
			var model = this.model;
			if (xattrs.$use) {
				$use = applyUserDirectives(this, xattrs, el);
            }
			for (var key in xattrs) {
				var up = null;
                var val = xattrs[key];
                if (key.charCodeAt(0) === 36) { // $ - extended attribute
					if (key === '$on') {
						applyListeners(el, model, val);
					} else if (key === '$class') {
						up = SetQClass(el, model, val);
					} else if (key === '$style') {
						up = SetStyle(el, model, val);
					} else if (key === '$show') {
						up = SetDisplay(el, model, val);
					} else if (key === '$toggle') {
						up = SetToggle(el, model, val);
					} else if (key === '$html') {
                        up = SetInnerHTML(el, model, val);
					} else if (key === '$attrs') {
						up = SetDOMAttrs(el, model, val);
					} else if (key === '$emit') {
						applyEmitters(el, model, val);
					} else if (key === '$slot') {
						el.__qute_slot__ = val;
					} else if (key === '$ref') {
						this.model[val] = el;
                    }
                } else if (key === 'class') {
                    // special handling of classes to sync with inherited class and q:class
                    if (typeof val === 'function') {
                        up = SetComputedClass(el, model, val);
                    } else {
                        SetFixedClass(el, val);
                    }
				} else if (typeof val === 'function') { // a dynamic binding
                    up = SetAttr(el, model, key, val);
                } else {
					el.setAttribute(key, val);
				}
				if (up) {
					this.up(up)(); // push then execute
				}
            }
        }

		if (children) { appendChildren(el, children); }
		// we should apply any user directive after the children are added.
		if ($use) {
			$use(this, el);
		}
		return el;
	},
	// element with static children (innerHTML is set from the subtree)
	hh:function(tag, xattrs, content, type) {
		var el = this.h(tag, xattrs);
		if (type === 'markdown') { // convert can be a function to convert the content before injecting in the dom
			content = this.md(content);
		}
		el.innerHTML = content;
		return el;
    },
    // a component
    c: function(renderFn, xattrs, children) {
        if (!renderFn) { // recursivity -> use the current render fn
            var vm = this.closestVM(); //TODO impl a closestComp? to support fucnctional templates too?
            if (!vm) { ERR('Calling "self" is only allowed inside a Viewodel context'); }
            renderFn = vm.constructor;
        }
        return this._c(renderFn, xattrs, extractSlots(children));
    },
	// vm component
    _c: function(XTag, xattrs, slots) { // a vm component (viewmodel)
        if (typeof XTag !== 'function') {
            ERR('component tag is not a function: %s', XTag);
        }
		if (XTag.prototype && XTag.prototype.__QUTE_VM__) { // a ViewModel
			var vm = new XTag(this.model.$app);
			return vm.$create(this, xattrs, slots);
		} else if (XTag.$compiled) { // a compiled template
			return new FunComp().render(this, XTag, xattrs, slots);
        } else { // a hand written function or a lazy component
			return XTag(this, xattrs, slots);
        }
	},
	s: function(slotName, defaultChildren) {
		var model = this.model;
		var slots = model.$slots;
		var children = slots && slots[slotName || 'default'] || defaultChildren;
		if (children) {
			var frag = document.createDocumentFragment();
			appendChildren(frag, children);
			return frag;
		}
		return document.createComment('[slot/]'); // placeholder
	},
	o: function(slotName, children) { // outer slot
		var slots = this.model.$slots;
		if (slots && slots[slotName] && children) {
			var frag = document.createDocumentFragment();
			appendChildren(frag, children);
			return frag;
		}
		return document.createComment('[outer-slot/]'); // placeholder
	},
	v: function(isExpr, changeCb, noCache, xattrs, childrenFn) { // dynamic view
		var renderFn = function(r, key) {
			return key ? r.c(key, xattrs, childrenFn(r)) : null;
		};
		return new SwitchFragment(this, 'view', isExpr, renderFn, changeCb, noCache).$create();
	},
	i: function(ifChain, kidsChain, changeCb) { // if / else-if / else
		// ifChain is a list of if expression functions corresponding to if / if-else else chain.
		// When 'else' is present - the last expression corresponding to the else will be null
		// kidsChain is a list of children functions corresponding to if / else-if / else chain
		// both lists have the same when length. When only 'if' is present the list is of length 1.
		var exprFn = function(model) {
			var i = 0;
			for (var l=ifChain.length-1; i<l; i++) {
				if (ifChain[i](model)) { return i; }
			}
			var lastExpr = ifChain[i];
			// if lastExpr is null is is corresponding to an else statement
			return !lastExpr || lastExpr(model) ? i : -1;
		};
		var renderFn = function(r, key) {
			return key > -1 ? kidsChain[key](r) : null;
		};
		return new SwitchFragment(this, 'if', exprFn, renderFn, changeCb).$create();
	},
	// dynamic lists - which is updating only items that changed
	l: function(listFn, iterationFn, key) {
		return new ListFragment(this, listFn, iterationFn, key).$create();
	},
	// static array variant of lists - this cannot be updated it is rendered once at creation
	a: function(listFn, iterationFn) {
		return new ForFragment(this, listFn, iterationFn).$create();
	},
	// dom element or fragment generated using custom user code.
	z: function(valueFn, frozen) {
		var value = valueFn(this.model);
		var start = document.createComment('[dom]');
		var end = document.createComment('[/dom]');
		var frag = document.createDocumentFragment();
		frag.appendChild(start);
		value && frag.appendChild(value);
		frag.appendChild(end);
		if (!frozen) { // if not frozen register update function
			this.up(UpdateUserDom(valueFn, this.model, start, end));
		}
		return frag;
	},
	up: function(fn) { // register a live update function
		this.ups.push(fn);
		return fn;
	},
	// eval the value of an xattr given the key - if a function invoke the function within the current context otherwise return the value as is
	eval: function(xattr) {
		return typeof xattr === 'function' ? xattr(this.model) : xattr;
	},

	// connect all nested renderings
	connect: function() {
		if (!this.isc) {
			var vm = this.vm;
			// before connect
			vm && vm.willConnect && vm.willConnect();
			var kids = this.kids;
			for (var i=0,l=kids.length; i<l; i++) { kids[i].connect(); }
			this.isc = true;
			// after connect
			vm && vm.connected && vm.connected();
		}
		return this;
	},
	// disconnect all nested renderings
	disconnect: function() {
		if (this.isc) {
			var vm = this.vm;
			// before disconnect
			vm && vm.willDisconnect && vm.willDisconnect();
			var kids = this.kids;
			for (var i=0,l=kids.length; i<l; i++) { kids[i].disconnect(); }
			this.isc = false;
			vm && vm.disconnected && vm.disconnected();
		}
		return this;
	},
	$push: function(r) { // push a sub-renderings
		this.kids.push(r);
		if (this.isc) { r.connect(); }
	},
	// refresh the DOM - call all nested update functions
	update: function() {
		var model = this.model, ups = this.ups;
		for (var i=0,l=ups.length;i<l;i++) { ups[i](model); }
		return this;
	},

	// run dom update recursively on each nested rendering
	refresh: function() {
		this.update();
		var kids = this.kids;
		for (var i=0,l=kids.length; i<l; i++) {
			var kid = kids[i];
			kid.refresh && kid.refresh();
		}
	},

	// create a child rendering
	spawn: function(model) {
		return new Rendering(this, model || this.model);
	},

	// get the closest VM in current rendering, ignore renderings which are not bound to ViewModel objects (template components etc)
	closestVM: function() {
		var r = this;
		do {
			if (r.vm) { return r.vm; }
			r = r.parent;
		} while (r);
		return null;
	},
	// to be used by custom directives to safely add fixed class names to an element
	addClass: function addClass(el, className) {
		AddClass(el, className);
	},
	get app() {
		return this.model.$app;
	}
};

function Rendering(parent, model) {
	this.parent = parent;
	/*
	 the model to use when rendering. The model should provide the following props:
	 	$app,
	 	$attrs,
	 	$slots
	 	and other data properties
	 */
	this.model = model;
	/*
	The associated ViewModel component if any. The VM contract is to provide the following methods:
	1. willConnect
	2. connected
	3. willDisconnect
	4. disconnected
	*/
	this.vm;
	this.ups = []; // the update listeners
	/*
	  Sub-rendering objects if any
	  A rendering object must provide the following functions:
	  	connect
	  	disconnect
	  	$update
	  	refresh
	*/
	this.kids = [];
	this.isc = false; // is connected?
}
Rendering.prototype = RenderingProto;

// a template component
Rendering.Template = FunComp;
// make the bindings visible to component implementors
// add more bindigns here if needed
Rendering.SetAttr = SetAttr;
Rendering.SetDisplay = SetDisplay;

function createProp(prop) {
	return {
		get: function get() {
			return prop.value;
		},
		set: function set(value) {
			prop.set(value);
		},
		enumerable: true
	};
}

var PropProto = {
	set: function set(value) {
		if (value !== this.value) {
			var old = this.value;
			this.value = value;
			this.app.post('model:'+this.key, value, old);
		}
	},
	get: function get() {
		return this.value;
	},

	addChangeListener: function addChangeListener(fn) {
		this.app.subscribe('model:'+this.key, fn);
		return fn;
	},

	removeChangeListener: function removeChangeListener(fn) {
		this.app.unsubscribe('model:'+this.key, fn);
	},

	inject: function inject(target, name) {
		Object.defineProperty(target, name, createProp(this));
		return this;
	},

	bindVM: function bindVM(vm, key) {
		var this$1 = this;

		vm.$data[key] = this.value; // set the initial value
		vm.setup(function () {
			this$1.app.subscribe('model:'+this$1.key, function(value, old) {
				var watcher = vm.$el && vm['$watch_'+key]; // if not connected whatchers are not enabled
				// avoid updating if watcher return false
				if (watcher && watcher.call(vm, value, old) === false) { return; }
				vm.update();
			});
		});
		return createProp(this);
    }
};

function Prop(app, key, defValue) {
	this.app = app;
	this.key = key;
	this.value = defValue;
	app.data[key] = this;
}
Prop.prototype = PropProto;

function Application(data) {
	this.topics = {};
	this.data = {};
	this.env = {};
	this.components = {}; // components lookup by id
	data && this.putAll(data);
}

Application.prototype = {
    __QUTE_APP__: true,
    // API for custom apps
    mount: function mount(elOrId, insertBefore) {
        if (!this.VM) {
            ERR('Cannot install application: only custom applications linked to a root ViewModel can be installed');
        }
        this.root = new (this.VM)(this);
        this.beforeMount && this.beforeMount();
        this.root.mount(elOrId, insertBefore);
        this.ready && this.ready();
        return this.root;
    },
    unmount: function unmount() {
        if (!this.root) { ERR('Cannot uninstall application: not installed'); }
        this.beforeUmount && this.beforeMount();
        this.root.umount();
        this.root = null;
        this.unmounted && this.unmounted();
	},
	// register / unregister components
	unpublish: function unpublish(key) {
		delete this.components[key];
	},
	lookup: function lookup(key) {
		return this.components[key];
	},
	publish: function publish(key, value) {
		if (key in this.components) { console.warning('A component was already registered as "', key, '"'); }
		this.components[key] = value;
	},
	post: function post(topic, msg, data) {
		var listeners = this.topics[topic];
		if (listeners) { for (var i=0,l=listeners.length;i<l;i++) {
			if (listeners[i](msg, data) === false) {
				break; // stop if one of the listeners returns false
			}
		} }
	},
	postAsync: function postAsync(topic, msg, data) {
		var self = this;
		window.setTimeout(function() { self.post(topic, msg, data); }, 0);
	},
	subscribe: function subscribe(topic, listenerFn) {
		var listeners = this.topics[topic];
		if (!listeners) {
			this.topics[topic] = listeners = [];
		}
		listeners.push(listenerFn);
		return this;
	},
	subscribeOnce: function subscribeOnce(topic, event, listenerFn) {
		var self = this;
		var onceSubscription = function(msg, data) {
			if (msg === event) {
				listenerFn(msg, data);
				self.unsubscribe(topic, onceSubscription);
			}
		};
		this.subscribe(topic, onceSubscription);
		return onceSubscription;
	},
	unsubscribe: function unsubscribe(topic, listenerFn) {
		var listeners = this.topics[topic];
		if (listeners) {
			var i = listeners.indexOf(listenerFn);
			if (i > -1) {
				listeners.splice(i, 1);
			}
		}
	},

	prop: function prop(key) {
		var prop = this.data[key];
		if (!prop) {
			ERR("No model property named '%s' was found!", key);
		}
		return prop;
    },
    defineProp: function defineProp(key, value) {
		return new Prop(this, key, value);
    },

	defineProps: function defineProps(props) {
		var data = this.data;
		for (var key in props) {
			data[key] = new Prop(this, key, props[key]);
		}
	},

	view: function view(VM) {
		return new VM(this);
    }
};

Application.Prop = Prop;

var TYPES = {};

var BaseType = {
    createProp: function createProp(vm, key, value, arg) {
        this.checkArgs && this.checkArgs(key, value, arg);
        var setter = this.setter;
        this.init.call(vm, key, value, arg, setter);
        return this.descriptor.call(vm, key, arg, setter);
    },
    /**
     * Initialize default value
     * @param {*} _value
     * @param {*} _factory
     * @param {*} setter
     */
    init: function init(key, value, arg, setter) {
        // initialize prop value
        this.$data[key] = setter ? setter.call(this, value, arg) : value;
    },
    /**
     * Get the property descriptor to be used with Object.defineProperty
     * @param {*} key
     * @param {*} arg
     * * @param {*} setter
     */
    descriptor: function descriptor(key, arg, setter) {
        return {
            get: function() {
                return this.$data[key];
            },
            set: function(value) {
                var old = this[key];
                if (setter) { value = setter.call(this, value, arg); }
                if (old !== value) {
                    this.$data[key] = value;
                    var watcher = this.$el && this['$watch_'+key]; // if not connected whatchers are not enabled
                    // avoid updating if watcher return false
                    if (watcher && watcher.call(this, value, old) === false) { return; }
                    this.update();
                }
            },
            enumerable: key.charCodeAt(0) !== 95 // keys starting with _ are not enumerable
        }
    }
};

function _detectType(val) {
    if (val != null) {
        var _type = typeof val;
        if (_type === 'string') {
            return TYPES.String;
        } else if (_type === 'number') {
            return TYPES.Number;
        } else if (_type === 'boolean') {
            return TYPES.Boolean;
        }
    }
    return null;
}

var AnyType = Object.create(BaseType);
AnyType.createProp = function(vm, key, value, arg) {
    var Type = _detectType(value);
    if (Type) { return Type.createProp(vm, key, value, arg); }
    // else setter is null
    var setter = null;
    this.init.call(vm, key, value, arg, setter);
    return this.descriptor.call(vm, key, arg, setter);
};


function registerType(Type, def) {
    var key = typeof Type === 'string' ? Type : Type.name;
    var typeObj = Object.assign(Object.create(BaseType), def || {});
    TYPES[key] = typeObj;
    return typeObj;
}

function getType(Type) {
    if (Type) {
        var typeObj = TYPES[typeof Type === 'string' ? Type : Type.name];
        if (!typeObj) { ERR('No such property type was found: '+Type); }
        return typeObj;
    }
    return AnyType;
}

/*
A helper for reactive lists udpates
*/
function List(vm, key, ar) {
    this.ar = ar ? ar.slice() : []; // always make a copy
    this.vm = vm;
    if (key === '.') {
		this.keyOf = function(item) { return String(item); };
	} else if (typeof key === 'string') {
		this.keyOf = function(item) { return item[key]; };
	} else { // expect a fn
		this.keyOf = key;
	}
}
List.prototype = {
    __QUTE_LIST__: true, // marker to be used by list-fragment.js
    toJSON: function toJSON(key) { // serializew the object as an array
        if (!key) { return this.ar; }
    },
    set: function set(ar) {
        if (!ar) { ar = []; }
        if (this.ar.length === 0 && ar.length === 0) {
            return;
        }
        if (ar !== this.ar) {
            this.ar = ar;
            this.vm.update();
        }
    },
    clear: function clear() {
        this.set([]);
    },
    size: function size() {
        return this.ar.length;
    },
    push: function push() {
        var r = this.ar.push.apply(this.ar, arguments);
        if (arguments.length > 0) {
            this.vm.update();
        }
        return r;
    },
    pop: function pop() {
        var r;
        if (this.ar.length > 0) {
            r = this.ar.pop();
            this.vm.update();
        }
        return r;
    },
    peek: function peek() {
        return this.ar[this.ar.length-1];
    },
    shift: function shift() {
        var r;
        if (this.ar.length > 0) {
            r = this.ar.shift();
            this.vm.update();
        }
        return r;
    },
    unshift: function unshift() {
        var r = this.ar.unshift.apply(this.ar, arguments);
        if (arguments.length > 0) {
            this.vm.update();
        }
        return r;
    },
    splice: function splice() {
        var r = this.ar.splice.apply(this.ar, arguments);
        this.vm.update();
        return r;
    },
    prepend: function prepend(array) {
        if (array && array.length > 0) {
            this.ar = array.concat(this.ar);
            this.vm.update();
        }
        return this;
    },
    append: function append(array) {
        if (array && array.length > 0) {
            this.ar = this.ar.concat(array);
            this.vm.update();
        }
        return this;
    },
    update: function update(updateFn) {
        if (!updateFn || updateFn(this.ar) !== false) {
            this.vm.update();
        }
        return this;
    },
    // keyed items related api
    getIndex: function getIndex(key) {
        var keyFn = this.keyOf, list = this.ar;
        for (var i=0,l=list.length; i<l; i++) {
            if (key === keyFn(list[i])) {
                return i;
            }
        }
        return -1;
    },
    getItem: function getItem(key) {
        var i = this.getIndex(key);
        return i < 0 ? undefined : this.ar[i];
    },
    setItem: function setItem(key, item) {
        var i = this.getIndex(key);
        if (i > -1) {
            this.ar[i] = item;
        }
    },
    removeItem: function removeItem(key) {
        var i = this.getIndex(key);
        if (i > -1) {
            this.ar.splice(i, 1);
            this.vm.update();
        }
        return this;
    },
    updateItem: function updateItem(key, updateFn) {
        var item = this.getItem(key);
        if (item !== undefined) {
            if (updateFn(item) !== false) {
                var list = this.ar;
                if (!list.__dirty__) {
                    list.__dirty__ = [];
                }
                list.__dirty__.push(key);
                this.vm.update();
            }
        }
        return this;
    },
    insertBefore: function insertBefore(item, beforeKey) {
        var i = this.getIndex(beforeKey);
        if (i > -1) {
            this.ar.splice(i, 0, item);
            this.vn.update();
        }
    },
    moveBefore: function moveBefore(key, beforeKey) {
        var index = this.getIndex(key);
        if (index === -1) { throw new Error('No such item '+ key); }
        var list = this.ar, beforeIndex = -1;
        if (beforeKey) {
            beforeIndex = this.getIndex(beforeKey);
        }
        if (index === beforeIndex) { return; }
        if (beforeIndex === -1) {
            list.push(list[index]);
            list.splice(index, 1);
        } else if (index < beforeIndex) {
            list.splice(beforeIndex, 0, list[index]);
            list.splice(index, 1);
        } else {
            list.splice(index, 1);
            list.splice(beforeIndex, 0, list[index]);
        }
        this.vm.update();
        return this;
    }
};

function Link(target, key, propName) {
    Object.defineProperty(target, key, target.$app.prop(propName).bindVM(target, key));
}

// the built-in types

function toString(val) {
    return val == null ? val : String(val);
}

function toNumber(val) {
    if (val != null) {
        var n = Number(val);
        if (isNaN(n)) { ERR('Expecting a number. Got: '+(typeof val)+': '+val); }
        return n;
    }
    return val;
}

function toBoolean(val) {
    return val == null ? val : Boolean(val);
}

function toArray(val) {
    if (val != null && !Array.isArray(val)) { ERR('Expected an array but got '+val); }
    return val;
}
/*
function isPlainObject(val) {
    return typeof val === 'object' && val.constructor === Object;
}
*/
function toObject(val) {
    if (val != null && typeof val !== 'object') { ERR('Expected an object but got '+val); }
    return val;
}
function toFunction(val) {
    if (val != null && typeof val !== 'function') { ERR('Expected a function but got '+val); }
    return val;
}
function toDate(val) {
    if (val != null) {
        if (val instanceof Date) {
            return val;
        } else {
            var type = typeof val;
            if (type === 'number' || type === 'string') {
                return new Date(val); // a string or a number
            }
        }
        ERR('Expecting a date value but got '+val);
    }
    return val;
}


registerType(String, {
    setter: toString
});
registerType(Boolean, {
    setter: toBoolean
});
registerType(Number, {
    setter: toNumber
});
registerType(Date, {
    setter: toDate
});
registerType(Array, {
    setter: toArray
});
registerType(Object, {
    setter: toObject
});
registerType(Function, {
    setter: toFunction
});
registerType(List, {
    setter: function setter(val, key) {
        if (val && !Array.isArray(val)) {
            ERR('Usupported value for list property: '+val);
        }
        return new List(this, key, val);
    },
    checkArgs: function checkArgs(key, value, arg) {
        if(!arg) { ERR('Reactive List properties must sepcify the list key as an argument!'); }
    }
});
//a link to the app data model (which is doing the same as @Inject)
registerType(Link, {
    createProp: function createProp(vm, key, value, arg) {
        if (!arg) { ERR('Link properties must specify the application data model key as an argument!'); }
        return vm.$app.prop(arg).bindVM(vm, key);
    }
});

function Property(Type, arg) {
    return function(vm, key, value) {
        vm.defineProp(Type, key, value, arg);
    }
}
Property.registerType = registerType;
Property.getType = getType;

function Inject(id) {
    return function(target, key, value) {
        // value is ignored!
        if (target.__QUTE_VM__) { // we need to install a reactive property
            Link(target, key, id);
        } else if (target.app) {
            target.app.prop(id).inject(target, key);
        } else {
            ERR('@Inject must be used on ViewModels or classes which provides an `app` property like Qute services');
        }
    }
}

/* To be shared by both class decorators in './index.js' and Qute facade */

/**
 * Assign a rendering function to the given ViewModel prototype
 * @param {*} VMProto
 * @param {*} fn
 */
function _template(VMProto, renderFn) {
    VMProto.render = renderFn;
}

/**
 * Apply the given mixins to the ViewModel given its prototype.
 * @param {*} mixins
 */
function _mixin(VMProto, mixins) {
    for (var i=0,l=mixins.length; i<l; i++) {
        Object.assign(VMProto, mixins[i]);
    }
}

/**
 * Define a watcher method on the given ViewwModel prototype
 * @param {*} VMProto
 * @param {*} prop
 * @param {*} fn
 */
function _watch(VMProto, prop, fn) {
    Object.defineProperty(VMProto, '$watch_'+prop, {value: fn});
}

/**
 * Define a DOM event listener to the given ViewModel prototype
 * @param {*} VMProto
 * @param {*} key
 * @param {*} selector
 * @param {*} cb
 */
function _on(VMProto, key, selector, cb) {
    VMProto.setup(function(thisObj) {
        thisObj.$on(key, selector, cb);
    });
}

/**
 * Define required properties given the ViewModel prototype and a list of property names
 * @param {*} VMProto
 * @param {*} names
 */
function _require(VMProto, names) {
    VMProto.$require = Array.prototype.slice.call(names);
}

/**
 * To be used on Qute.Application derived classes
 * @param {*} renderFn
 */
function View(VM) {
    return function(target) {
        target.prototype.VM = VM;
    }
}

function Template(renderFn) {
    return function(target) {
        _template(target.prototype, renderFn);
    }
}

function Mixin() {
    var args = arguments;
    return function(target) {
        _mixin(target.prototype, args);
    }
}

/**
 * Register an event listener
 * @param {string} event
 * @param {*string} selector
 */
function On(event, selector) {
    return function(VMProto, name, descriptor) {
        _on(VMProto, event, selector, descriptor.value);
    }
}

function Watch(prop) {
    return function(VMProto, name, descriptor) {
        _watch(VMProto, prop, descriptor.value);
    }
}

function Required() {
    return function(VMProto, name, descriptor) {
        //do nothing --> properties are handled by the compiler for optimizations
    }
}

function Provide(id) {
    return function(target, key, value) {
        var app;
        if (target.__QUTE_APP__) {
            app = target;
        } else if (target.app) {
            app = target.app;
        } else {
            ERR('The @Provide decorator is meant to be used on Qute.Application or Qute.Service classes, or on any class providig a `app` field of type Qute.Application!');
        }
        app.defineProp(id, value).inject(target, key);
    }
}

// set $attrs on VMs
function SetVMAttrs(vm, parentVM, filter) {
	return function() {
		var parentAttrs = parentVM.$attrs;
		if (parentAttrs) {
            var keys = filterKeys(parentAttrs, filter);
			for (var i=0,l=keys.length; i<l; i++) {
				var key = keys[i];
				vm.$set(key, parentAttrs[key]);
			}
		}
	}
}

function ViewModel(app) {
	if (!app) { app = new Application(); }
	var prop = {};
	// the attributes set on vm tag which are not declared as props
	prop.value = {};
	Object.defineProperty(this, '$attrs', prop);
	// the app context if any
	prop.value = app;
	Object.defineProperty(this, '$app', prop);
	// the listeners registered on the vm tag
	prop.value = null;
	prop.writable = true;
	// the associated rendering context
	Object.defineProperty(this, '$r', prop);
	// the slots injected by the caller
	Object.defineProperty(this, '$slots', prop);
	// the view root element
	Object.defineProperty(this, '$el', prop);
	// chained cleanup functions if any was registered
	Object.defineProperty(this, '$clean', prop);
	// States: 0 - initial, 1 - connected, 2 - updating
	prop.value = 0;
	Object.defineProperty(this, '$st', prop); // state: 0 - default, bit 1 - connected, bit 2 - update queued

	prop.value = {};
    Object.defineProperty(this, '$data', prop);

	if (!this.render) { ERR("No render function defined for the ViewModel!"); }
}

ViewModel.prototype = {
    __QUTE_VM__: true, // ViewModel marker
	toString: function() {
		return 'ViewModel <'+this.render.name+'/>';
	},
	// set an attribute value (can be either a free property (i.e $attrs[key]) or managed property (i.e. $data[key]))
	$set: function(key, value) {
		if (key in this.$data) { // a declared property
			this[key] = value;
		} else {
			var camelKey = kebabToCamel(key);
			if (camelKey !== key && camelKey in this.$data) {
				this[camelKey] = value;
			} else if (this.$attrs[key] !== value) {
				// attributes are not camelized
				this.$attrs[key] = value;
				this.update();
			}
		}
	},
	//TODO use setup in listen and $on
	setup: function(setupFn) {
		this.$setup = chainFnAfter(setupFn, this.$setup);
		return this;
	},
	cleanup: function(fn) { // register a cleanup function when component is disconnected
		this.$clean = chainFnAfter(fn, this.$clean);
		return this;
	},
	$parent: function() {
		if (!this.$r) { return null; }
		return this.$r.closestVM();
	},
	$root: function() {
		var parent = this.$parent();
		return parent ? parent.$root() : this;
	},
	connect: function() {
		this.$r && this.$r.connect();
	},
	disconnect: function() {
		this.$r && this.$r.disconnect();
	},
	refresh: function() {
		this.$r && this.$r.refresh();
	},
	isConnected: function isConnected() {
		return this.$r && this.$r.isc;
	},
	willConnect: function() {
		// TODO the connected flag is no mor euseful since we can use $r.isc
		if (this.$st & 1) { return; } // ignore
		this.$st |= 1; // set connected flag
		// $setup may be defined by the prototype to do automatic setup when connected
		// (e.g. automatic installed listeners defined though VM definitioan 'on' property)
		if (this.$setup) {
			this.$setup(this);
		}

		// TODO update DOM if previously disconnected
		//if (false) this.$update();

		// call the connected callback
		//this.connected && this.connected();
		return this;
	},
	willDisconnect: function() {
		if (!(this.$st & 1)) { return; } // ignore
		this.$st ^= 1; // clear connected flag
		if (this.$clean) {
			this.$clean(this);
			this.$clean = null;
		}
	},
	publish: function(id) {
		this.setup(function(vm) {
			vm.$app.publish(id, vm);
			vm.cleanup(function(vm) {
				vm.$app.unpublish(id);
			});
		});
	},
	lookup: function lookup(id) {
		return this.$app.lookup(id);
	},
	// initialize a vm from tag raw data
	$load: function(rendering, xattrs, slots) {
		var bindings = null;
		var model = rendering.model;
		this.$slots = slots;
		if (xattrs) {
			for (var key in xattrs) {
				var val = xattrs[key];
				if (key.charCodeAt(0) === 36) { // $ - extended attribute
					if (key === '$attrs') { // we must not delete keys from xattrs since it can break when vm is loaded by a dynamic component
						//TODO DO WE NEED to add an update fn? q:attrs are static
						rendering.up(SetVMAttrs(this, model, val))();
					} else if (key === '$class') {
						if (!bindings) { bindings = []; }
						bindings.push(InheritQClass, val);
					} else if (key === '$style') {
						if (!bindings) { bindings = []; }
						bindings.push(SetStyle, val);
					} else if (key === '$show') {
						if (!bindings) { bindings = []; }
						bindings.push(SetDisplay, val);
					} else if (key === '$toggle') {
						if (!bindings) { bindings = []; }
						bindings.push(SetToggle, val);
					}
				} else if (typeof val === 'function') { // a dynamic binding
					rendering.up(SetProp(this, model, key, val))();
				} else { // static binding
					this.$set(key, val);
				}
			}
        }
        if (this.$require) {
            var req = this.$require;
            for (var i=0,l=req.length; i<l; i++) {
                if (this.$data[req[i]] == null) {
                    ERR('Required property is not defined: "'+req[i]+'" in '+this.toString());
                }
            }
        }
		return bindings;
	},
	$create: function(parentRendering, xattrs, slots) {
		var $use,
			model = parentRendering && parentRendering.model,
            listeners = xattrs && xattrs.$on,
            emitters = xattrs && xattrs.$emit;

		// we need to call user direcrtives before creating the element and loading bindings
		// to give a chance to the directive to inject properties
        if (xattrs && xattrs.$use) {
			$use = applyUserDirectives(parentRendering, xattrs, null, this);
		}

		// load definition
		var bindings = parentRendering && this.$load(parentRendering, xattrs, slots);

        var rendering = new Rendering(parentRendering, this);
		rendering.vm = this;
        this.$r = rendering;

		this.initialized && this.initialized();

		// must never return null - for non rendering components like popups we return a comment
		var el = this.render(rendering) || window.document.createComment('<'+this.toString()+'/>');
		el.__qute__ = this;
        this.$el = el;
        this.created && this.created(el);

		if (bindings) { for (var i=0,l=bindings.length; i<l; i+=2) {
			var up = bindings[i](el, model, bindings[i+1]);
			parentRendering.up(up)();
        } }

        if (emitters) {
            applyEmitters(el, model, emitters);
        }

		if (listeners) {
			applyListeners(el, model, listeners);
		}

		// should use parent vm as context for custom directives
		if ($use) { $use(parentRendering, el); }
		if (parentRendering && xattrs && xattrs.$ref) {
			parentRendering.model[xattrs.$ref] = this;
		}

		// this can trigger a connect if tree is already connected (for example when inserting a comp in a connected list)
		parentRendering && parentRendering.$push(rendering);

        this.ready && this.ready(el);

		return el;
	},

	// manual mount (only roots must be moutned this way)
	mount: function(elOrId, insertBefore) {
		if (this.$r) { ERR("VM is already mounted"); }
		var target;
		if (elOrId) {
			target = typeof elOrId === 'string' ? window.document.getElementById(elOrId) : elOrId;
		} else {
			target = window.document.body;
		}
		var el = this.$create();
		if (insertBefore) {
			target.parentNode.insertBefore(el, target);
		} else {
			target.appendChild(el);
		}
		this.connect();
		// announce the tree was attached to the DOM
		return this;
	},
	// only manually mounted vms can be unmounted
	unmount: function() {
		// a child vm?
		if (!this.r) { ERR("VM is not mounted"); }
		this.disconnect();
		this.$el.parentNode.removeChild(this.$el);
		this.$el = null;
	},
	debugUpdate: function debugUpdate(debug) {
		this.$upcnt = debug ? 0 : -1;
	},
	$update: function() {
		if (this.$r) { // TODO only if connected
			// notify app debugger if any
			this.$app.debugger && this.$app.debugger('update', this);
			this.$r.update();
            //TODO fire an update event?
		}
	},
	update: function() {
		if (this.$st === 1) { // only if connected and not already scheduled to update
			this.$st |= 2; // set updating flag
			var self = this;
			UpdateQueue.push(function() {
				self.$update();
				self.$st ^= 2; // remove updating flag
			});
		}
	},
	$on: function(type/*, selector, cb*/) {
		if (!this.$el) { ERR("View not connected"); }
		//if (!this.$clean) this.$clean = [];
		var selector, cb;
		if (arguments.length === 3) {
			selector = arguments[1];
			cb = arguments[2];
			if (!cb) {
				cb = selector;
				selector = null;
				if (!cb) { throw new Error('on function requires a callback argument'); }
			}
		} else if (arguments.length === 2) {
			cb = arguments[1];
		} else {
			throw new Error('on function takes 2 or 3 arguments: eventType[, seelctor], callback');
		}
		var self = this;
		var wrapper = function(e) {
			if (!selector || e.target.matches(selector)) {
				if (cb.call(self, e) === false) {
					stopEvent(e);
				}
			}
		};
		this.$el.addEventListener(type, wrapper);
		this.cleanup(function() {
			self.$el.removeEventListener(type, wrapper);
		});
		//this.$clean.push(type, wrapper);
    },
    defineProp: function(Type, key, value, arg) {
        Object.defineProperty(this, key, Property.getType(Type).createProp(this, key, value, arg));
    },
    emit: Emitter.emit,
	emitAsync: Emitter.emitAsync,
	// -------- app event bus helper functions -------------
	post: function(topic, msg, data) {
		this.$app.post(topic, msg, data);
	},
	postAsync: function(topic, msg, data) {
		this.$app.postAsync(topic, msg, data);
	},
	// ---------------------------------------------
	toHTML: function() {
		return this.$el && this.$el.outerHTML;
	}
};

function Service(app) {
    if (!app) { ERR('Invalid service constructor: you must pass to the Qute.Service super class an "app" argument'); }
    this.app = app;
}
Service.prototype = {
    __QUTE_SVC__: true
};

/**
 * We cannot use Object.assign since getter are lost. So we copy the prop def itself
 */
function assignPropDefs(dst, src) {
	var keys = Object.keys(src);
    for(var i=0,l=keys.length; i<l; i++) {
      var key = keys[i];
      Object.defineProperty(dst, key, Object.getOwnPropertyDescriptor(src, key));
    }
    return dst;
}

function Qute(renderFn, def) {
    if (!def) {
        if (typeof renderFn === 'function') {
            def = {};
        } else {
            def = renderFn;
            renderFn = null;
        }
    } else if (typeof renderFn !== 'function') {
        ERR("Usage: Qute(RenderFunction[, Model])");
    }

	function ViewModelImpl(app) {
        ViewModel.call(this, app);
        this.init && this.init(app);
	}

	var VMType, VMProto;
    var BaseVm = ViewModel;
    VMProto = Object.create(BaseVm.prototype, {
        constructor: { value: ViewModelImpl },
    });
    if (def) { assignPropDefs(VMProto, def); } // this is preserving getters
    VMProto.$super = BaseVm.prototype; // to be able to override methods and call the super method if needed
    ViewModelImpl.prototype = VMProto;
    VMType = ViewModelImpl;

    // add the rendering method of the tag if no one was provided
    if (renderFn) { VMProto.render = renderFn; }

    if (!VMProto.render) {
        ERR('Unsupported ViewModel definition: No rendering function was defined');
    }

	VMType.watch = function(prop, fn) {
        _watch(VMProto, prop, fn);
		return VMType;
	};
	VMType.on = function(key, selector, cb) {
        _on(VMProto, key, selector, cb);
		return VMType;
	};
    VMType.mixin = function() {
        _mixin(VMProto, Array.prototype.slice.call(arguments));
        return VMType;
    };
    VMType.require = function() {
        _require(VMProto, Array.prototype.slice.call(arguments));
        return VMType;
    };
	return VMType;
}

Qute.ViewModel = ViewModel;
Qute.Application = Application;
Qute.UpdateQueue = UpdateQueue;
Qute.Rendering = Rendering;
Qute.Service = Service;

// decorators an types
Qute.View = View;
Qute.Template = Template;
Qute.Render = Template; // export Template under the name Render too.
Qute.Mixin = Mixin;
Qute.On = On;
Qute.Watch = Watch;
Qute.Required = Required;
Qute.Provide = Provide;
Qute.Property = Property;
Qute.Inject = Inject;
Qute.Link = Link; // a custom property type to create links similar to @Inject
Qute.List = List;

// render a template component given its render function name and a model
Qute.render = function(renderFn, model) {
	return renderFn(new Rendering(null, model));
};
Qute.defineMethod = function(name, fn) {
	//define method on both ViewModel and template components prototype
	ViewModel.prototype[name] = fn;
    Rendering.Template.prototype[name] = fn;
};
Qute.runAfter = function(cb) { UpdateQueue.runAfter(cb); };
// get a component from its root element
Qute.get = function(elt) { return elt.__qute__; };
// Qute.import is added by @qutejs/importer

// store Qute instance in window - this is important so that imported components use the same Qute instance
window.Qute = Qute;

export default Qute;
//# sourceMappingURL=index.js.map
